import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./index.module.scss";
import Speedometer from "./SpeedometerChart";
import DoughnutChart from "./DoughnutChart";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { getDataSources } from "../../services";
import { getCustomPlugInDetails } from "../../services/cusstomPlugIn.service";
import DataQuality from "./DataQuality";
import JobMonitor from "./JobMonitor";
import {
  getJobDetails,
  // getCurrentJobExecutionDetails,
  getJobTaskGroupDetails,
  getJobExecutionStatus,
  getJobExecutionHistory,
  getCurrentJobExecutionDetails,
} from "../../services/JobManagement.service";
import {
  getDmDataQuality,
  getRdvDataQuality,
} from "../../services/Dashboard.service";
import CustomLoader from "../../components/Loader/Spinner";
import refreshIcon from "../../components/Icons/refresh.svg";
import {
  FaCopy,
  // FaCopy,
  FaFilter,
  FaInfoCircle,
} from "react-icons/fa";

import { Pagination } from "react-bootstrap";
import { IGetJobManagementInterface } from "../../interfaces/jobManagement.interfaces";
import * as api from "../../services/middleware/api.middleware";
import { getAuthHeader } from "../../services/auth/authHeaders";

type Props = {
  currentPage: number;         // 1-based
  totalPages: number;          // >= 1
  onPageChange: (page: number) => void;
  maxVisiblePages?: number;    // optional (default 5)
  disabled?: boolean;          // optional
  className?: string;          // optional
};

const PaginationBar: React.FC<Props> = ({
  currentPage,
  totalPages,
  onPageChange,
  maxVisiblePages = 5,
  disabled = false,
  className,
}) => {
  if (totalPages <= 0) return null;

  const items: React.ReactNode[] = [];

  // First & Prev
  items.push(
    <Pagination.First
      key="first"
      disabled={disabled || currentPage === 1}
      onClick={() => onPageChange(1)}
    />,
    <Pagination.Prev
      key="prev"
      disabled={disabled || currentPage === 1}
      onClick={() => onPageChange(Math.max(1, currentPage - 1))}
    />
  );

  // Always show page 1
  items.push(
    <Pagination.Item
      key={1}
      active={currentPage === 1}
      onClick={() => onPageChange(1)}
      className={`custom-pagination-item ${currentPage === 1 ? "active" : ""}`}
      disabled={disabled}
    >
      1
    </Pagination.Item>
  );

  // Middle window with ellipses
  if (totalPages > 1) {
    const half = Math.floor(maxVisiblePages / 2);
    let startPage = Math.max(2, currentPage - half);
    let endPage = Math.min(totalPages - 1, currentPage + half);

    // Adjust window when near edges
    if (currentPage <= half + 1) {
      startPage = 2;
      endPage = Math.min(totalPages - 1, maxVisiblePages);
    } else if (currentPage >= totalPages - half) {
      startPage = Math.max(2, totalPages - maxVisiblePages + 1);
      endPage = totalPages - 1;
    }

    if (startPage > 2) items.push(<Pagination.Ellipsis key="start-ellipsis" disabled={disabled} />);

    for (let p = startPage; p <= endPage; p++) {
      items.push(
        <Pagination.Item
          key={p}
          active={p === currentPage}
          onClick={() => onPageChange(p)}
          className={`custom-pagination-item ${p === currentPage ? "active" : ""}`}
          disabled={disabled}
        >
          {p}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages - 1) items.push(<Pagination.Ellipsis key="end-ellipsis" disabled={disabled} />);

    // Always show last page
    items.push(
      <Pagination.Item
        key={totalPages}
        active={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
        className={`custom-pagination-item ${currentPage === totalPages ? "active" : ""}`}
        disabled={disabled}
      >
        {totalPages}
      </Pagination.Item>
    );
  }

  // Next & Last
  items.push(
    <Pagination.Next
      key="next"
      disabled={disabled || currentPage === totalPages}
      onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
    />,
    <Pagination.Last
      key="last"
      disabled={disabled || currentPage === totalPages}
      onClick={() => onPageChange(totalPages)}
    />
  );

  return <Pagination className={className}>{items}</Pagination>;
};


const DashBoard = () => {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState<any>([]);
  const [customPlugIn, setCustomPlugIn] = useState<any>([]);
  const [jobData, setJobData] = useState<any>([]);
  const [jobTaskGroupData, setJobTaskGroupData] = useState<any>([]);
  const [jobTaskGroupTypeData, setJobTaskGroupTypeData] = useState<any>({
    bronze: 0,
    silver: 0,
    gold: 0,
  });
  const [jobTaskGroupActiveTypeData, setJobTaskGroupActiveTypeData] =
    useState<any>({
      bronze: 0,
      silver: 0,
      gold: 0,
    });
  const environment_id = Number(localStorage.getItem("environment_id"));
  const [dqMonitorTab, setDqMonitorTab] = useState<boolean>(false);
  const [jobMonitorTab, setJobMonitorTab] = useState<boolean>(false);
  // const [jobStatusCount, setJobStatusCount] = useState<any>();
  const [currectJobData, setCurrentJobData] = useState<any>();
  const [currectJTGData, setCurrentJTGData] = useState<any>();
  const [jobTimeData, setJobTimeData] = useState<any>(null);
  const [jobMonitorData, setJobMonitorData] = useState<any>(null);
  const [jobExecutionStatus, setJobExectionStatus] = useState<any>([]);
  const [jobTableData, setJobTableData] = useState<any>([]);
  const [jobExecutionHistory, setJobExecutionHistory] = useState<any>([]);
  const [jobExecutionHistoryChartData, setJobExecutionHistoryChartData] =
    useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDqLoading, setIsDqLoading] = useState<boolean>(false);
  const [bronzeLayerData, setBronzeLayerData] = useState<any>({
    name: "",
    value: [],
  });
  const [silverLayerData, setSilverLayerData] = useState<any>({
    name: "",
    value: [],
  });
  const [goldLayerData, setGoldLayerData] = useState<any>({
    name: "",
    value: [],
  });
  const [jobDurationStartDate, setJobDurationStartDate] = useState(null);
  const [jobDurationEndDate, setJobDurationEndDate] = useState(null);
  const [jobExecutionStartDate, setJobExecutionStartDate] = useState(null);
  const [jobExecutionEndDate, setJobExecutionEndDate] = useState(null);

  const originalDataRef = useRef<any[]>([]);

  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [statusCounts, setStatusCounts] = useState<{
    Queued: number;
    Initiated: number;
    Failed: number;
    Running: number;
    Succeeded: number;
  }>({
    Queued: 0,
    Initiated: 0,
    Failed: 0,
    Running: 0,
    Succeeded: 0,
  });

  useEffect(() => {
    const currentDate = new Date();
    const thirtyDaysAgo = new Date();
    const threeDaysAgo = new Date();
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);
    threeDaysAgo.setDate(currentDate.getDate() - 3);

    setJobExecutionStartDate(threeDaysAgo.toISOString().split("T")[0]);
    setJobExecutionEndDate(currentDate.toISOString().split("T")[0]);
    setJobDurationStartDate(thirtyDaysAgo.toISOString().split("T")[0]);
    setJobDurationEndDate(currentDate.toISOString().split("T")[0]);
  }, []);

  const getStatus = (status: any) => {
    const currentSpeed =
      status === "Queued"
        ? 20
        : status === "Initiated"
        ? 60
        : status === "Running"
        ? 140
        : status === "Failed"
        ? 100
        : status === "Succeeded"
        ? 180
        : status === "undefined"
        ? 0
        : 0;
    return currentSpeed;
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  // const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const getJobExectionHistoryData = () => {
    getJobExecutionHistory(jobDurationStartDate, jobDurationEndDate)
      .then((res: any) => {
        setJobExecutionHistory(res);
        const getRandomColor = () =>
          `#${Math.floor(Math.random() * 16777215).toString(16)}`;

        function getLatestRecords(data: any) {
          const latestRecordsMap = data.reduce((acc: any, current: any) => {
            const key = `${current.job_name}_${current.start_time.slice(0, 10)}`;
            const existingRecord = acc.get(key);

            if (
              !existingRecord ||
              new Date(current.start_time) > new Date(existingRecord.start_time)
            ) {
              acc.set(key, current);
            }

            return acc;
          }, new Map<string, any>());

          return Array.from(latestRecordsMap.values());
        }

        const latestRecords: any = getLatestRecords(res);

        let uniqueDatesSet;
        uniqueDatesSet = new Set(
          latestRecords.map((entry: any) => entry.start_time.split("T")[0])
        );

        const uniqueDates = Array.from(uniqueDatesSet);

        const datasets = latestRecords.map((runId: any) => {
          const counts = uniqueDates.map((date) => {
            const entry = latestRecords.find(
              (item: any) =>
                item.start_time.split("T")[0] === date &&
                item.job_name === runId.job_name
            );
            return entry ? entry.job_duration / 60 : 0;
          });

          const color = getRandomColor();
          return {
            label: runId.job_name,
            data: counts,
            borderColor: color,
            backgroundColor: color,
            tension: 0,
            borderDash: [0],
          };
        });

        const uniqueArray = datasets.reduce((accumulator: any, current: any) => {
          const existingItem = accumulator.find(
            (item: any) => item.label === current.label
          );
          if (!existingItem) {
            return [...accumulator, current];
          }
          return accumulator;
        }, []);

        const chartData: any = {
          labels: uniqueDates,
          datasets: uniqueArray,
        };

        setJobExecutionHistoryChartData(chartData);
      })
      .catch();
  };

  const getJobExecutionStatusData = () => {
    getJobExecutionStatus(jobExecutionStartDate, jobExecutionEndDate)
      .then((res) => {
        setJobMonitorData(res);

        const groupedData = res.reduce((acc: any, curr: any) => {
          const date = new Date(curr.job_start_time).toLocaleDateString();
          const key = curr.job_name + "-" + date;
          if (
            !acc[key] ||
            new Date(acc[key].job_start_time) < new Date(curr.job_start_time)
          ) {
            acc[key] = curr;
          }
          return acc;
        }, {});

        const filteredData: any = Object.values(groupedData);

        const calculateDuration = (startTime: any, endTime: any) => {
          const start: any = new Date(startTime);
          const end: any = new Date(endTime);
          const durationInMilliseconds: any = Math.abs(end - start);
          const hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
          const minutes = Math.floor(
            (durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor(
            (durationInMilliseconds % (1000 * 60)) / 1000
          );
          return `${hours}:${minutes}:${seconds}`;
        };

        const validData = (data: any) => {
          data.forEach((job: any) => {
            if (job.job_end_time === null) {
              job.job_end_time = new Date().toISOString();
              job.formatted_duration = calculateDuration(
                job.job_start_time,
                job.job_end_time
              );
              const startDate: any = new Date(job.job_start_time);
              const endDate: any = new Date(job.job_end_time);
              const durationInMilliseconds: any = endDate - startDate;
              job.job_duration = Math.floor(durationInMilliseconds / 1000);
            }

            job.job_task_groups.forEach((group: any) => {
              if (group.job_task_group_end_time === null) {
                group.job_task_group_end_time = new Date().toISOString();
                group.formatted_duration = calculateDuration(
                  group.job_task_group_start_time,
                  group.job_task_group_end_time
                );
                const startDate: any = new Date(group.job_task_group_start_time);
                const endDate: any = new Date(group.job_task_group_end_time);
                const durationInMilliseconds: any = endDate - startDate;
                group.job_task_group_duration = Math.floor(
                  durationInMilliseconds / 1000
                );
              }

              group.job_tasks.forEach((task: any) => {
                if (task.job_task_end_time === null) {
                  task.job_task_end_time = new Date().toISOString();
                  task.formatted_duration = calculateDuration(
                    task.job_task_start_time,
                    task.job_task_end_time
                  );
                  const startDate: any = new Date(task.job_task_start_time);
                  const endDate: any = new Date(task.job_task_end_time);
                  const durationInMilliseconds: any = endDate - startDate;
                  task.job_task_duration = Math.floor(
                    durationInMilliseconds / 1000
                  );
                }
              });
            });
          });
        };

        validData(filteredData);

        filteredData.sort(
          (a: any, b: any) =>
            new Date(b.job_start_time).getTime() -
            new Date(a.job_start_time).getTime()
        );

        const layerOrder: any = {
          Bronze: 0,
          Silver: 1,
          Gold: 2,
        };

        filteredData.forEach((job: any) => {
          job.job_task_groups.sort(
            (a: any, b: any) => layerOrder[a.layer] - layerOrder[b.layer]
          );
        });

        filteredData.forEach((job: any) => {
          job.job_task_groups.forEach((group: any) => {
            group.job_tasks.sort((a: any, b: any) => {
              if (a.job_step_type_id !== b.job_step_type_id) {
                return a.job_step_type_id - b.job_step_type_id;
              } else {
                return (
                  new Date(a.job_task_start_time).getTime() -
                  new Date(b.job_task_start_time).getTime()
                );
              }
            });
          });
        });
        setJobExectionStatus(filteredData);
      })
      .catch();
  };

  useEffect(() => {
    jobDurationEndDate !== null &&
      jobDurationStartDate !== null &&
      getJobExectionHistoryData();
  }, [jobDurationEndDate, jobDurationStartDate]);

  useEffect(() => {
    jobExecutionStartDate !== null &&
      jobExecutionEndDate !== null &&
      getJobExecutionStatusData();
  }, [jobExecutionStartDate, jobExecutionEndDate]);


  const fetchJobMonitorDetails = (nextPage: number = page, nextLimit: number = limit) => {
  setIsLoading(true);
  setJobExectionData([]);

  getCurrentJobExecutionDetails(nextPage, nextLimit, statusFilter, jobNameFilter).then((res) => {
    const items = res?.items ?? [];

    setStatusCounts(res?.status_counts);

    function sortByStartDateAndJobStatus(a: any, b: any): number {
      const statusPreference = ["Failed", "Running", "Initiated", "Queued", "Succeeded"];

      if (a.job_start_time === null && b.job_start_time !== null) {
        return 1;
      }
      if (a.job_start_time !== null && b.job_start_time === null) {
        return -1;
      }
      if (a.job_start_time !== null && b.job_start_time !== null) {
        const timeDifference =
          new Date(b.job_start_time).getTime() - new Date(a.job_start_time).getTime();
        if (timeDifference !== 0) {
          return timeDifference;
        }
      }

      return (
        statusPreference.indexOf(a.job_task_status) -
        statusPreference.indexOf(b.job_task_status)
      );
    }

    const sortedData: any = items.sort(sortByStartDateAndJobStatus);

    function calculateOverallStatus(data: any) {
      const statusPreference = ["Failed", "Running", "Initiated", "Queued", "Succeeded"];

      let overallStatus = "Succeeded";
      for (let i = 0; i < data.length; i++) {
        const currentStatus = data[i].job_task_status;

        if (statusPreference.indexOf(currentStatus) < statusPreference.indexOf(overallStatus)) {
          overallStatus = currentStatus;
        }
        if (overallStatus === "Failed") break;
      }
      return overallStatus;
    }

    const overallStatus = calculateOverallStatus(sortedData);
    setCurrentJobData({ jobStatus: getStatus(overallStatus) });
    if (sortedData.length) handleTableRowClick(sortedData[0]);
    setJobTableData(sortedData);
    originalDataRef.current = sortedData;

    // 🔹 Set pagination meta (keeps your logic intact)
    setPage(res.page ?? nextPage);
    setLimit(res.limit ?? nextLimit);
    // setTotal(res.total ?? sortedData.length);
    setTotalPages(res.total_pages ?? Math.max(1, Math.ceil((res.total ?? sortedData.length) / (res.limit ?? nextLimit))));

    setIsLoading(false);
  }).catch(() => {
    setIsLoading(false);
  });

  // keep your other calls exactly as you had them
  jobExecutionStartDate !== null &&
    jobExecutionEndDate !== null &&
    getJobExecutionStatusData();

  jobDurationEndDate !== null &&
    jobDurationStartDate !== null &&
    getJobExectionHistoryData();
};

useEffect(() => {
  fetchJobMonitorDetails(1, limit);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

const handleJobMonitorRefresh = () => {
  setIsLoading(true);
  fetchJobMonitorDetails(page, limit);
};

const goToPage = (p: number) => {
  if (p < 1 || p > totalPages) return;
  fetchJobMonitorDetails(p, limit);
};


  const fetchDqMonitorDetails = () => {
    getDataSources(environment_id).then((res) => {
      setDataSource(res);
    });
    getCustomPlugInDetails().then((res) => {
      setCustomPlugIn(res);
    });
    getJobDetails().then((res) => {
      setJobData(res);
    });
    getRdvDataQuality().then((res: any) => {
      if (res.length === 0) {
        setSilverLayerData({
          name: "Silver DQ Status",
          value: [
            {
              data_mart_name: "null",
              data_vault_test_passed: "NO_RECORD",
            },
          ],
        });
      } else {
        setSilverLayerData({ name: "Silver DQ Status", value: res });
      }
      setIsDqLoading(false);
    });

    getDmDataQuality().then((res: any) => {
      if (res.length === 0) {
        setGoldLayerData({
          name: "Gold DQ Status",
          value: [
            {
              data_mart_name: "null",
              data_mart_test_passed: "NO_RECORD",
            },
          ],
        });
      } else {
        setGoldLayerData({ name: "Gold DQ Status", value: res });
      }
      setIsDqLoading(false);
    });

    setBronzeLayerData({
      name: "Bronze DQ Status",
      value: [
        {
          data_mart_name: "null",
          data_mart_test_passed: "NO_RECORD",
        },
      ],
    });
  };

  useEffect(() => {
    setIsLoading(true);
    fetchJobMonitorDetails();
    setIsDqLoading(true);
    fetchDqMonitorDetails();
  }, []);

  useEffect(() => {
    if (jobData?.length > 0) {
      const jobId = jobData.map((value: any) => value.job_id);
      const jobTaskGroups: any = [];
      jobId.forEach((job_id: any, index: any) => {
        getJobTaskGroupDetails(job_id).then((data) => {
          jobTaskGroups.push({ jobId: job_id, taskGroups: data });
          if (index === jobId.length - 1) {
            setJobTaskGroupData(jobTaskGroups);
          }
        });
      });
    }
  }, [jobData]);

  useEffect(() => {
    jobTaskGroupData?.length > 0 && countTaskGroupsByLayer(jobTaskGroupData);
  }, [jobTaskGroupData]);

  const setJobExectionData = (res: any) => {
    const distinctRecords = res.filter((record: any, index: any, array: any) => {
      return !array.slice(0, index).some(
        (prevRecord: any) =>
          prevRecord.job_name === record.job_name &&
          prevRecord.job_start_time === record.job_start_time &&
          prevRecord.job_end_time === record.job_end_time
      );
    });

    const processedData: any = {};
    distinctRecords.forEach((record: any) => {
      const date: any = new Date(record.job_start_time).toLocaleDateString();

      const startTime = new Date(record.job_start_time);
      const endTime = new Date(record.job_end_time);
      const runtime = (endTime.getTime() - startTime.getTime()) / (1000 * 60);

      if (!processedData[record.job_name]) {
        processedData[record.job_name] = { labels: [], data: [], status: "" };
      }
      processedData[record.job_name].labels.push(date);
      processedData[record.job_name].data.push(runtime);
      processedData[record.job_name].status = record.status;
    });

    const datasets = Object.keys(processedData).map((jobName) => ({
      label: jobName,
      data: processedData[jobName].data,
      status: processedData[jobName].status,
      borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
      tension: 0,
      borderDash: [0],
    }));

    const chartData = {
      labels: processedData[Object.keys(processedData)[0]]?.labels,
      datasets,
    };
    setJobTimeData(chartData);
  };

  const dqMonitorButtonClick = () => {
    setDqMonitorTab(true);
  };

  const jobMonitorButtonClick = () => {
    setJobMonitorTab(true);
  };

  const countTaskGroupsByLayer = (jobTaskGroupData: any) => {
    const taskGroups = jobTaskGroupData.map((value: any) => value.taskGroups);
    const flattenedArray = [].concat(...taskGroups.map((innerArray: any) => innerArray));
    const layerCounts: any = {};
    flattenedArray?.length > 0 &&
      flattenedArray.forEach((taskGroup: any) => {
        const layerId = taskGroup.layer_id;
        if (layerCounts[layerId]) {
          layerCounts[layerId] = layerCounts[layerId] + 1;
        } else {
          layerCounts[layerId] = 1;
        }
      });

    const updatedObject = {
      bronze: layerCounts["1"],
      silver: layerCounts["2"],
      gold: layerCounts["3"],
    };
    setJobTaskGroupTypeData(updatedObject);

    const layerCountsActive: any = {};
    flattenedArray?.length > 0 &&
      flattenedArray.forEach((taskGroup: any) => {
        const layerId = taskGroup.layer_id;
        if (taskGroup.is_active === true) {
          if (layerCountsActive[layerId]) {
            layerCountsActive[layerId]++;
          } else {
            layerCountsActive[layerId] = 1;
          }
        }
      });

    const updatedObjectActive = {
      bronze: layerCountsActive["1"],
      silver: layerCountsActive["2"],
      gold: layerCountsActive["3"],
    };
    setJobTaskGroupActiveTypeData(updatedObjectActive);
  };

  const getJobTaskGroupCount = () => {
    const countArray = jobTaskGroupData?.map((item: any) => ({
      jobId: item.jobId,
      count: item.taskGroups.length,
    }));
    const totalCount = countArray?.reduce((total: any, item: any) => total + item.count, 0);
    return totalCount ? totalCount : 0;
  };

  const getJobTaskGroupActiveCount = () => {
    const countArray = jobTaskGroupData?.map((item: any) => ({
      jobId: item.jobId,
      count: item.taskGroups.reduce((count: any, obj: any) => {
        if (obj.is_active === true) {
          return count + 1;
        }
        return count;
      }, 0),
    }));
    const totalCount = countArray?.reduce((total: any, item: any) => total + item.count, 0);
    return totalCount ? totalCount : 0;
  };

  const calculatePercentages = (response: any) => {
    const totalCount = response?.value?.length || 1;

    const status =
      response.name === "Bronze DQ Status"
        ? "data_mart_test_passed"
        : response.name === "Silver DQ Status"
        ? "data_vault_test_passed"
        : "data_mart_test_passed";
    const statusCounts = response?.value?.reduce((acc: any, curr: any) => {
      acc[curr[status]] = (acc[curr[status]] || 0) + 1;
      return acc;
    }, {});

    const failedPercentage = statusCounts?.["FAILED"] || 0;
    const passedPercentage = statusCounts?.["PASSED"] || 0;
    const noRecordPercentage = ((statusCounts?.["NO_RECORD"] || 0) / totalCount) * 100;

    return {
      chartType: response.name,
      failedPercentage,
      passedPercentage,
      noRecordPercentage,
    };
  };

  const chartData = [bronzeLayerData, silverLayerData, goldLayerData].map(
    (apiResponse, index) => ({
      ...calculatePercentages(apiResponse),
      id: index,
    })
  );

  const handleTableRowClick = (row: any) => {
    setSelectedRowId(makeRowId(row));

    const effectiveStatus = row?.job_task_status ?? row?.job_task_status ?? "N/A";

    setCurrentJTGData(() => ({
      bronzeJtgStatus: row?.layer === "Bronze" ? getStatus(effectiveStatus) : null,
      silverJtgStatus: row?.layer === "Silver" ? getStatus(effectiveStatus) : null,
      goldJtgStatus: row?.layer === "Gold" ? getStatus(effectiveStatus) : null,
    }));

    setCurrentJobData({ jobStatus: getStatus(effectiveStatus) });
  };

  // const handleJobMonitorRefresh = () => {
  //   setIsLoading(true);
  //   fetchJobMonitorDetails();
  // };

  const handleDqMonitorRefresh = () => {
    setIsDqLoading(true);
    setDataSource([]);
    setCustomPlugIn([]);
    setJobData([]);
    setJobTaskGroupData([]);
    setSilverLayerData({
      name: "",
      value: [],
    });
    setGoldLayerData({
      name: "",
      value: [],
    });
    setBronzeLayerData({
      name: "",
      value: [],
    });
    setJobTaskGroupTypeData({
      bronze: 0,
      silver: 0,
      gold: 0,
    });
    setJobTaskGroupActiveTypeData({
      bronze: 0,
      silver: 0,
      gold: 0,
    });
    fetchDqMonitorDetails();
  };

  const handleCopyToClipboard = (text: string) => {
    // @ts-ignore
    navigator.clipboard.writeText(text).then(() => {
      return null;
    });
  };

  const [mousePosition, setMousePosition] = useState<{ x: number; y: number } | null>(
    null
  );
  const tableRef = useRef<HTMLTableElement>(null);

  const handleMouseMove = (event: MouseEvent) => {
    setMousePosition({ x: event.clientX, y: event.clientY });
  };

  const handleScroll = () => {
    if (!tableRef.current || !mousePosition) return;

    const tableRect = tableRef.current.getBoundingClientRect();
    const rows = Array.from(tableRef.current.querySelectorAll("tbody tr"));

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      const rowRect = row.getBoundingClientRect();

      if (
        mousePosition.x >= tableRect.left &&
        mousePosition.x <= tableRect.right &&
        mousePosition.y >= rowRect.top &&
        mousePosition.y <= rowRect.bottom
      ) {
        break;
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousemove", handleMouseMove);
    tableRef.current?.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      tableRef.current?.removeEventListener("scroll", handleScroll);
    };
  }, [mousePosition]);

  const [isScrolling, setIsScrolling] = useState(false);
  const scrollTimeout = useRef(null);

  const handleScrollV2 = () => {
    if (!isScrolling) {
      setIsScrolling(true); // Set to true when scrolling starts
    }

    if (scrollTimeout.current) {
      // @ts-ignore
      clearTimeout(scrollTimeout.current);
    }

    // @ts-ignore
    scrollTimeout.current = setTimeout(() => {
      setIsScrolling(false); // Set to false when scrolling stops
    }, 200); // Adjust timeout duration as needed
  };

  useEffect(() => {
    return () => {
      // Clear timeout on unmount
      if (scrollTimeout.current) {
        // @ts-ignore
        clearTimeout(scrollTimeout.current);
      }
    };
  }, []);

// const [jobNameSearch, setJobNameSearch] = useState("");

  // const allJobNames = useMemo(() => {
  //   const src = (originalDataRef.current?.length ? originalDataRef.current : jobTableData) ?? [];
  //   const set = new Set<string>();
  //   for (const r of src) {
  //     if (r?.job_name) set.add(r.job_name);
  //   }
  //   return Array.from(set).sort((a, b) => a.localeCompare(b));
  // }, [jobTableData.length]); // re-evaluate if dataset size changes

// SINGLE-VALUE filters (applied)
const [statusFilter, setStatusFilter] = useState<string | null>(null);
const [jobNameFilter, setJobNameFilter] = useState<string | null>(null);

// SINGLE-VALUE temps (inside popovers)
const [tempStatusFilter, setTempStatusFilter] = useState<string | null>(null);
const [tempJobNameFilter, setTempJobNameFilter] = useState<string | null>(null);

  const STATUS_OPTIONS = ["Running", "Queued", "Initiated", "Succeeded", "Failed", "Cancel"];

  const statusFilterBtnRef = useRef<HTMLButtonElement | null>(null);

const latestReqIdRef = useRef(0);

const processResponse = useCallback((res: any, nextPage: number, nextLimit: number) => {
  const items = res?.items ?? [];

  function sortByStartDateAndJobStatus(a: any, b: any): number {
    const statusPreference = ["Failed", "Running", "Initiated", "Queued", "Succeeded"];

    if (a.job_start_time === null && b.job_start_time !== null) return 1;
    if (a.job_start_time !== null && b.job_start_time === null) return -1;

    if (a.job_start_time !== null && b.job_start_time !== null) {
      const timeDifference = new Date(b.job_start_time).getTime() - new Date(a.job_start_time).getTime();
      if (timeDifference !== 0) return timeDifference;
    }

    return statusPreference.indexOf(a.job_task_status) - statusPreference.indexOf(b.job_task_status);
  }

  const sortedData = items.sort(sortByStartDateAndJobStatus);

  function calculateOverallStatus(data: any[]) {
    const statusPreference = ["Failed", "Running", "Initiated", "Queued", "Succeeded"];
    let overallStatus = "Succeeded";
    for (let i = 0; i < data.length; i++) {
      const currentStatus = data[i].job_task_status;
      if (statusPreference.indexOf(currentStatus) < statusPreference.indexOf(overallStatus)) {
        overallStatus = currentStatus;
      }
      if (overallStatus === "Failed") break;
    }
    return overallStatus;
  }

  const overallStatus = calculateOverallStatus(sortedData);
  setCurrentJobData({ jobStatus: getStatus(overallStatus) });

  if (sortedData.length) handleTableRowClick(sortedData[0]);

  setJobTableData(sortedData);
  originalDataRef.current = sortedData;

  setPage(res.page ?? nextPage);
  setLimit(res.limit ?? nextLimit);
  setTotalPages(
    res.total_pages ?? Math.max(1, Math.ceil((res.total ?? sortedData.length) / (res.limit ?? nextLimit)))
  );
}, [
  // setJobStatusCount,
  setCurrentJobData,
  setJobTableData,
  setPage,
  setLimit,
  setTotalPages,
  handleTableRowClick
]);

const loadJobs = useCallback(async ({
  nextPage,
  nextLimit,
  nextStatus,
  nextJobName,
}: {
  nextPage: number;
  nextLimit: number;
  nextStatus: string | null;
  nextJobName: string | null;
}) => {
  setIsLoading(true);
  const reqId = ++latestReqIdRef.current;
  try {
    const res = await getCurrentJobExecutionDetails(nextPage, nextLimit, nextStatus, nextJobName);
    // ignore stale responses
    if (reqId !== latestReqIdRef.current) return;
    processResponse(res, nextPage, nextLimit);
  } catch (e) {
    if (reqId !== latestReqIdRef.current) return;
    // optional: toast error
  } finally {
    if (reqId === latestReqIdRef.current) setIsLoading(false);
  }
}, [processResponse]);

useEffect(() => {
  loadJobs({ nextPage: 1, nextLimit: limit, nextStatus: statusFilter, nextJobName: jobNameFilter });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  // STATUS
  const applyStatusFilter = async () => {
    setStatusFilter(tempStatusFilter);
    await loadJobs({ nextPage: 1, nextLimit: limit, nextStatus: tempStatusFilter, nextJobName: jobNameFilter });
    // const next = applyAllFilters(originalDataRef.current, tempStatusFilter, jobNameFilter);
    // setJobTableData(next);
  };
  const clearStatusFilter = async () => {
    setTempStatusFilter(null);
    setStatusFilter(null);
    await loadJobs({ nextPage: 1, nextLimit: limit, nextStatus: null, nextJobName: jobNameFilter });
    // const next = applyAllFilters(originalDataRef.current, [], jobNameFilter);
    // setJobTableData(next);
  };

  // JOB NAME
  const applyJobNameFilter = async () => {
    setJobNameFilter(tempJobNameFilter);
    await loadJobs({ nextPage: 1, nextLimit: limit, nextStatus: statusFilter, nextJobName: tempJobNameFilter });
    // const next = applyAllFilters(originalDataRef.current, statusFilter, tempJobNameFilter);
    // setJobTableData(next);
  };
  const clearJobNameFilter = async () => {
    setTempJobNameFilter(null);
    setJobNameFilter(null);
    await loadJobs({ nextPage: 1, nextLimit: limit, nextStatus: statusFilter, nextJobName: null });
    // const next = applyAllFilters(originalDataRef.current, statusFilter, []);
    // setJobTableData(next);
  };

  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoRow, setInfoRow] = useState<any | null>(null);

  const openInfoModal = (row: any) => {
    setInfoRow(row);
    setShowInfoModal(true);
  };

  const closeInfoModal = () => {
    setShowInfoModal(false);
    setInfoRow(null);
  };

  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

  const makeRowId = (d: any) =>
    `${d.job_execution_id}|${d.job_name}|${d.job_task_group_name}|${d.job_task_name}|${d.job_step_type_name}|${
      d.pipeline_execution_id ?? "NA"
    }`;

// state
const [jobNameOptions, setJobNameOptions] = useState<string[]>([]);
const [jobNamesLoading, setJobNamesLoading] = useState(false);
const [jobNamesError, setJobNamesError] = useState<string | null>(null);
// const [jobNamePopoverOpen, setJobNamePopoverOpen] = useState(false);

// fetch all job names for env (unique, sorted)
const getEnvironmentId = () => {
  return localStorage.getItem("environment_id");
};
const getAccessToken = () => getAuthHeader();

async function fetchAllJobNames() {
  setJobNamesLoading(true);
  setJobNamesError(null);
  const serviceUrl = "environments";
  try {
    // const url = `https://wade-saas-portal-api-dev.azurewebsites.net/environments/${envId}/jobs`;
    // const res = await fetch(url, {
    //   headers: {
    //     // add auth if needed:
    //     // Authorization: `Bearer ${getAccessToken()}`,
    //   },
    // });
    const res = api.get<IGetJobManagementInterface[]>(
        `${serviceUrl}/${getEnvironmentId()}/jobs`,
        getAccessToken()
      );
    // if (!res.ok) throw new Error(`Jobs fetch failed: ${res.status}`);
    const data: Array<{ job_name?: string | null }> = await res;

    // unique (case-insensitive), then sort case-insensitively
    const seen = new Set<string>();
    const names: string[] = [];
    for (const item of data) {
      const raw = (item.job_name ?? "").trim();
      if (!raw) continue;
      const key = raw.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        names.push(raw);
      }
    }
    names.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
    setJobNameOptions(names);
  } catch (e: any) {
    setJobNamesError(e?.message || "Failed to load job names");
  } finally {
    setJobNamesLoading(false);
  }
}

  return (
    <>
      <div className={style.dashboardMainContainer}>
        {/* <BreadCrumbs breadCrumbsData={importDataModelBreadCrumbData} /> */}
        <div className={style.dashboardHeader}>
          <div>
            <div className={style.dashboardHeaderText}>
              {dqMonitorTab ? "Data Quality History" : jobMonitorTab ? "Job History" : "Dashboard"}
            </div>
            {!dqMonitorTab && !jobMonitorTab ? (
              <div className={style.dashboardHeaderSubtext}>
                Real-time orchestration, data quality insights, and operational reporting in one view.
              </div>
            ) : null}
          </div>
          {!dqMonitorTab && !jobMonitorTab ? (
            <div className={style.dashboardHeaderActions}>
              <Button
                className={style.dashboardTabButton}
                onClick={() => navigate("/dashboard/api-call-summary")}
                aria-label="Open API call cost and execution summary"
              >
                API Call Cost &amp; Execution Summary
              </Button>
            </div>
          ) : null}
        </div>
        {!dqMonitorTab && !jobMonitorTab && (
          <div className={style.dashboardContentContainer}>
            <div className={style.dashboardPanelsWrapper}>
              <div className={style.dashboardTopPanels}>
                <div className={style.orchestrationContainer}>
                  <div className={style.orchestrationContainerHeader}>
                    <div className={style.orchestrationHeaderHeading}>
                      Job Monitor - Current Job Orchestration Status
                    </div>
                    <img
                      alt="refresh_icon"
                      src={refreshIcon}
                      width={30}
                      className={style.refreshIcon}
                      onClick={handleJobMonitorRefresh}
                    ></img>
                  </div>
                  <div className={style.orchestrationChartContainer}>
                    <div className={style.orchestrationGaugeMeterChart}>
                      <div className={style.orchestrationGaugeMeterChartforJob}>
                        <div className={style.chartBox}>
                          <Speedometer
                            currentSpeed={currectJobData?.jobStatus}
                            totalSpeed={200}
                            height={200}
                            width={200}
                            type="Job"
                          />
                        </div>
                        <div className={style.jobMonitorBox}>
                          <div className={style.jobMonitorButton}>
                            <Button className={style.customButton} onClick={jobMonitorButtonClick}>
                              Job History
                            </Button>
                          </div>
                          <div className={style.jobMonitorStatus}>
                            <div className={style.jobMonitorStatusItem}>
                              <div className={style.jobMonitorStatusColorGrey}></div>
                              Queued / Canceled
                            </div>
                            <div className={style.jobMonitorStatusItem}>
                              <div className={style.jobMonitorStatusColorBlue}></div>
                              Initiated
                            </div>
                            <div className={style.jobMonitorStatusItem}>
                              <div className={style.jobMonitorStatusColorRed}></div>
                              Failed
                            </div>
                            <div className={style.jobMonitorStatusItem}>
                              <div className={style.jobMonitorStatusColorYellow}></div>
                              Running
                            </div>
                            <div className={style.jobMonitorStatusItem}>
                              <div className={style.jobMonitorStatusColorGreen}></div>
                              Succeeded
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`${style.dwInfoChartBox} ${style.taskMetricsGrid}`}>
                        <div className={style.taskMetricCard}>
                          Number of Queued Job Tasks : {statusCounts?.Queued ? statusCounts?.Queued : 0}
                        </div>
                        <div className={style.taskMetricCard}>
                          Number of Initiated Job Tasks :{" "}
                          {statusCounts?.Initiated ? statusCounts?.Initiated : 0}
                        </div>
                        <div className={style.taskMetricCard}>
                          Number of Succeeded Job Tasks :{" "}
                          {statusCounts?.Succeeded ? statusCounts?.Succeeded : 0}
                        </div>
                        <div className={style.taskMetricCard}>
                          Number of Failed Job Tasks : {statusCounts?.Failed ? statusCounts?.Failed : 0}
                        </div>
                        <div className={style.taskMetricCard}>
                          Number of Running Job Tasks : {statusCounts?.Running ? statusCounts?.Running : 0}
                        </div>
                      </div>
                      <div className={style.orchestrationGaugeMeterChartforJtg}>
                        <div className={style.jtgChartBox}>
                          <Speedometer
                            currentSpeed={currectJTGData?.bronzeJtgStatus}
                            totalSpeed={200}
                            height={60}
                            width={60}
                            type="Bronze"
                          />
                        </div>
                        <div className={style.jtgChartBox}>
                          <Speedometer
                            currentSpeed={currectJTGData?.silverJtgStatus}
                            totalSpeed={200}
                            height={60}
                            width={60}
                            type="Silver"
                          />
                        </div>
                        <div className={style.jtgChartBox}>
                          <Speedometer
                            currentSpeed={currectJTGData?.goldJtgStatus}
                            totalSpeed={200}
                            height={60}
                            width={60}
                            type="Gold"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={style.qualityStatusContainer}>
                  <div className={style.qualityStatus}>
                    <div className={style.qualityStatusHeader}>
                      <div className={style.orchestrationHeaderHeading}>
                        DQ Monitor - Current Data Lakehouse Data Quality
                      </div>
                      <img
                        alt="refresh_icon"
                        src={refreshIcon}
                        width={32}
                        className={style.refreshIcon}
                        onClick={handleDqMonitorRefresh}
                      ></img>
                    </div>
                    <div className={style.qualityStatusChartContainer}>
                      {isDqLoading && <CustomLoader variant="blue" />}
                      {!isDqLoading &&
                        chartData.map((value: any) => {
                          if (value.chartType === "Not Valid") {
                            return null;
                          } else {
                            return (
                              <div className={style.dataQualityChartBox}>
                                <DoughnutChart
                                  chartData={chartData}
                                  type={value.chartType}
                                  label={["Failed", "Succeeded", "No Record"]}
                                />
                              </div>
                            );
                          }
                        })}
                      <div className={style.dataQualityChartBox}>
                        <div className={style.dataQualityButton}>
                          <Button className={style.customButton} onClick={dqMonitorButtonClick}>
                            DQ History
                          </Button>
                        </div>
                        <div className={style.dataQualityStatus}>
                          <div className={style.dataQualityStatusItem}>
                            <div className={style.dataQualityStatusColorGrey}></div>
                            No record
                          </div>
                          <div className={style.dataQualityStatusItem}>
                            <div className={style.dataQualityStatusColorGreen}></div>
                            Succeeded
                          </div>
                          <div className={style.dataQualityStatusItem}>
                            <div className={style.dataQualityStatusColorRed}></div>
                            Failed
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={style.dwInfo}>
                    <div className={style.dwInfoHeader}>Data Lakehouse/ DW Info</div>
                    <div className={style.dwInfoChart}>
                      <div className={style.dwInfoChartContainer}>
                        <div className={style.dwInfoChartBox}>
                          <div className={style.dwInfoChartBoxContent}>
                            Number of Sources :
                            {dataSource &&
                              ` ${dataSource?.length} (${dataSource?.reduce((count: any, obj: any) => {
                                if (obj.is_active === true) {
                                  return count + 1;
                                }
                                return count;
                              }, 0)})`}
                          </div>
                          <div className={style.dwInfoChartBoxContent}>
                            Number of Endpoints :
                            {dataSource &&
                              ` ${dataSource?.reduce(
                                (count: any, obj: any) => count + obj.source_entity.length,
                                0
                              )} (${dataSource?.reduce((count: any, obj: any) => {
                                return (
                                  count +
                                  obj.source_entity.reduce((innerCount: any, innerObj: any) => {
                                    if (innerObj.is_active === true) {
                                      return innerCount + 1;
                                    }
                                    return innerCount;
                                  }, 0)
                                );
                              }, 0)})`}
                          </div>
                          <div className={style.dwInfoChartBoxContent}>
                            Number of Plugins :
                            {customPlugIn &&
                              ` ${customPlugIn?.length} (${customPlugIn?.reduce((count: any, obj: any) => {
                                if (obj.is_active === true) {
                                  return count + 1;
                                }
                                return count;
                              }, 0)})`}
                          </div>
                        </div>
                      </div>
                      <div className={`${style.dwInfoChartBox} ${style.dwInfoScrollableBox}`}>
                        <div className={style.dwInfoChartBoxContent}>
                          Number of Jobs :{" "}
                          {`${jobData?.length} (${jobData?.reduce((count: any, obj: any) => {
                            if (obj.is_active === true) {
                              return count + 1;
                            }
                            return count;
                          }, 0)})`}
                        </div>
                        <div className={style.dwInfoChartBoxContent}>
                          Number of Job Task Groups : {`${getJobTaskGroupCount()} (${getJobTaskGroupActiveCount()})`}
                        </div>
                        <div className={style.dwInfoChartBoxContent}>
                          Number of Bronze Job Task Groups :{" "}
                          {`${jobTaskGroupTypeData?.bronze} (${jobTaskGroupActiveTypeData?.bronze})`}
                        </div>
                        <div className={style.dwInfoChartBoxContent}>
                          Number of Silver Job Task Groups :{" "}
                          {`${jobTaskGroupTypeData?.silver} (${jobTaskGroupActiveTypeData?.silver})`}
                        </div>
                        <div className={style.dwInfoChartBoxContent}>
                          Number of Gold Job Task Groups :{" "}
                          {`${jobTaskGroupTypeData?.gold} (${jobTaskGroupActiveTypeData?.gold})`}
                        </div>
                      </div>
                    </div>
                    <div className={style.dwInfoChartTip}>
                      * Number within ( ) represents active entities
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.tableSectionShell}>
                <div className={style.orchestrationTable}>
                  {isLoading ? (
                    <CustomLoader variant="blue" />
                  ) : (
                    <div ref={scrollRef} className={style.tableScroll} onScroll={handleScrollV2}>
                      {jobTableData.length > 0 ? (
                        <>
                        <table ref={tableRef} className={style.jobManagementTableStrip}>
                          <thead>
                            <tr className={style.jobManagementTableHead}>
                              <th className="align-middle">Execution Id</th>
                              {/* <th className="align-middle">Job Name</th> */}
                              <th className="align-middle">
                                <div className={style.headerCellInline}>
                                  <span>Job Name</span>
{/* 
                                  <OverlayTrigger
  trigger="click"
  rootClose
  placement="bottom"
  container={() => scrollRef.current || document.body}
  overlay={
    <Popover id="jobname-filter-pop" className={style.popover3D} style={{ minWidth: 260 }}>
      <Popover.Header as="h3" className={style.popoverHeader}>Filter by Job Name</Popover.Header>
      <Popover.Body className={style.popoverBody}>
        <input
          type="text"
          value={jobNameSearch}
          onChange={(e) => setJobNameSearch(e.target.value)}
          placeholder="Search job names…"
          style={{ width: "100%", marginBottom: 8, padding: "6px 8px" }}
        />

        <div style={{ maxHeight: 220, overflowY: "auto", paddingRight: 4, border: "1px solid #ddd", borderRadius: 4 }}>
          {allJobNames
            .filter((name) => name.toLowerCase().includes(jobNameSearch.toLowerCase()))
            .map((name) => {
              const checked = tempJobNameFilter === name;
              const disabled = tempJobNameFilter !== null && tempJobNameFilter !== name;
              return (
                <label key={name} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px", opacity: disabled ? 0.6 : 1 }}>
                  <input
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setTempJobNameFilter(name);      // select one
                      } else {
                        setTempJobNameFilter(null);      // unselect -> re-enable all
                      }
                    }}
                  />
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{name}</span>
                </label>
              );
            })}
          {allJobNames.length === 0 && (
            <div style={{ padding: 8, color: "#666" }}>No job names found</div>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
          <Button size="sm" variant="outline-secondary" onClick={clearJobNameFilter}>Clear</Button>
          <Button size="sm" onClick={applyJobNameFilter} disabled={tempJobNameFilter === jobNameFilter}>Apply</Button>
        </div>
      </Popover.Body>
    </Popover>
  }
  onToggle={(next) => {
    if (next) {
      setTempJobNameFilter(jobNameFilter); // sync temp on open
      setJobNameSearch("");
    }
  }}
>
  <button type="button" className={style.filterIconBtn} aria-label="Filter by job name" title="Filter by job name">
    <FaFilter />
    {jobNameFilter && <span className={style.filterBadge}>1</span>}
  </button>
</OverlayTrigger> */}
<OverlayTrigger
  trigger="click"
  rootClose
  placement="bottom"
  container={() => scrollRef.current || document.body}
  overlay={
    <Popover id="jobname-filter-pop" className={style.popover3D} style={{ minWidth: 280 }}>
      <Popover.Header as="h3" className={style.popoverHeader}>Filter by Job Name</Popover.Header>
      <Popover.Body className={style.popoverBody}>
        <div
          style={{ maxHeight: 240, overflowY: "auto", paddingRight: 4, border: "1px solid #ddd", borderRadius: 4 }}
        >
          {jobNamesLoading && <div style={{ padding: 8, color: "#666" }}>Loading…</div>}
          {jobNamesError && <div style={{ padding: 8, color: "#b00" }}>{jobNamesError}</div>}
          {!jobNamesLoading && !jobNamesError && jobNameOptions.length === 0 && (
            <div style={{ padding: 8, color: "#666" }}>No job names found</div>
          )}

          {!jobNamesLoading && !jobNamesError && jobNameOptions.map((name) => {
            const checked = tempJobNameFilter === name;
            const disabled = tempJobNameFilter !== null && tempJobNameFilter !== name;
            return (
              <label
                key={name}
                style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px", opacity: disabled ? 0.6 : 1 }}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={disabled}
                  onChange={(e) => setTempJobNameFilter(e.target.checked ? name : null)}
                />
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{name}</span>
              </label>
            );
          })}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
          <Button size="sm" variant="outline-secondary" onClick={clearJobNameFilter}>Clear</Button>
          <Button size="sm" onClick={applyJobNameFilter} disabled={tempJobNameFilter === jobNameFilter}>
            Apply
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  }
  onToggle={async (open) => {
    // setJobNamePopoverOpen(open);
    if (open) {
      // sync temp selection
      setTempJobNameFilter(jobNameFilter);
      // fetch options if not loaded yet (or refetch if you prefer)
      if (jobNameOptions.length === 0) {
        await fetchAllJobNames(); // or pass 114 directly if fixed
      }
    }
  }}
>
  <button type="button" className={style.filterIconBtn} aria-label="Filter by job name" title="Filter by job name">
    <FaFilter />
    {jobNameFilter && <span className={style.filterBadge}>1</span>}
  </button>
</OverlayTrigger>
                                </div>
                              </th>
                              <th className="align-middle">Job Task Group</th>
                              <th className="align-middle">Job Task</th>
                              {/* <th className="align-middle">Status</th> */}
                              <th className="align-middle">
                                <div className={style.headerCellInline}>
                                  <span>Job Task Status</span>

                                  <OverlayTrigger
  trigger="click"
  rootClose
  placement="bottom"
  container={() => scrollRef.current || document.body}
  overlay={
    <Popover id="status-filter-pop" className={style.popover3D} style={{ minWidth: 220 }}>
      <Popover.Header as="h3" className={style.popoverHeader}>Filter by Status</Popover.Header>
      <Popover.Body className={style.popoverBody}>
        <div style={{ display: "grid", gap: 6 }}>
          {STATUS_OPTIONS.map((opt) => {
            const checked = tempStatusFilter === opt;
            const disabled = tempStatusFilter !== null && tempStatusFilter !== opt;
            return (
              <label key={opt} style={{ display: "flex", alignItems: "center", gap: 8, opacity: disabled ? 0.6 : 1 }}>
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={disabled}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTempStatusFilter(opt);     // select one
                    } else {
                      setTempStatusFilter(null);    // unselect -> re-enable all
                    }
                  }}
                />
                <span>{opt}</span>
              </label>
            );
          })}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
          <Button size="sm" variant="outline-secondary" onClick={clearStatusFilter}>Clear</Button>
          <Button size="sm" onClick={applyStatusFilter} disabled={tempStatusFilter === statusFilter}>Apply</Button>
        </div>
      </Popover.Body>
    </Popover>
  }
  onToggle={(next) => {
    if (next) setTempStatusFilter(statusFilter); // sync temp on open
  }}
>
  <button
    ref={statusFilterBtnRef}
    type="button"
    className={style.filterIconBtn}
    aria-label="Filter status"
    title="Filter status"
  >
    <FaFilter />
    {statusFilter && <span className={style.filterBadge}>1</span>}
  </button>
</OverlayTrigger>
                                </div>
                              </th>
                              <th className="align-middle">data_source_entity/target_entity</th>
                              <th className="align-middle">Job Task Start Time</th>
                              <th className="align-middle">Job Task End Time</th>
                              <th className="align-middle">Duration (hh:mm:ss)</th>
                              <th className="align-middle">Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {jobTableData.map((data: any, rowIndex: any) => {
                              return (
                                <tr
                                  key={makeRowId(data)}
                                  className={
                                    selectedRowId === makeRowId(data)
                                      ? style.jobManagementTableRowSelected
                                      : style.jobManagementTableRow
                                  }
                                  onClick={() => handleTableRowClick(data)}
                                >
                                  {[
                                    { content: data.job_execution_id, index: 1 },
                                    { content: data.job_name, index: 2 },
                                    { content: data.job_task_group_name, index: 3 },
                                    { content: data.job_task_name, index: 4 },
                                    {
                                      content: (
                                        <div className={style.statusContainer}>
                                          {data.job_task_status === "Queued" || data.job_task_status === "SkippedDueToFailure"  ? (
                                            <div className={style.jobMonitorStatusColorGrey}></div>
                                          ) : data.job_task_status === "Initiated" ? (
                                            <div className={style.jobMonitorStatusColorBlue}></div>
                                          ) : data.job_task_status === "Failed" ? (
                                            <div className={style.jobMonitorStatusColorRed}></div>
                                          ) : data.job_task_status === "Running" ? (
                                            <div className={style.jobMonitorStatusColorYellow}></div>
                                          ) : data.job_task_status === "Cancel" ? (
                                            <div className={style.jobMonitorStatusColorGrey}></div>
                                          ) : (
                                            <div className={style.jobMonitorStatusColorGreen}></div>
                                          )}
                                          <div>{data.job_task_status}</div>
                                        </div>
                                      ),
                                      index: 5,
                                    },
                                    { content: data["data_source_entity/target_entity"], index: 6 },
                                    { content: data.job_task_start_time, index: 7 },
                                    { content: data.job_task_end_time, index: 8 },
                                    { content: data.job_task_elapsed_time, index: 9 },
                                  ].map((cell) => (
                                    <td className="align-middle" key={cell.index}>
                                      {cell.content}
                                    </td>
                                  ))}

                                  {/* NEW Info cell */}
                                  <td className="align-middle" style={{ textAlign: "center", width: 56 }}>
                                    <button
                                      type="button"
                                      className={style.infoIconBtn}
                                      title="Show details"
                                      aria-label="Show details"
                                      onClick={(e) => {
                                        e.stopPropagation(); // don’t trigger row select
                                        openInfoModal(data);
                                      }}
                                    >
                                      <FaInfoCircle />
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        {/* <div className={style.tableFooter} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderTop: "1px solid #e5e7eb" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span>Rows per page:</span>
                            <select value={limit} onChange={changeLimit} disabled={isLoading}>
                              {[10,25,50,100].map(n => <option key={n} value={n}>{n}</option>)}
                            </select>
                          </div>

                          <div>
                            {total > 0 ? (
                              <>Showing <strong>{(page - 1) * limit + 1}</strong>–<strong>{Math.min(page * limit, total)}</strong> of <strong>{total}</strong></>
                            ) : <>No results</>}
                          </div>

                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <button onClick={() => goToPage(1)} disabled={isLoading || page <= 1}>⏮ First</button>
                            <button onClick={goPrev} disabled={isLoading || page <= 1}>‹ Prev</button>
                            <span>Page {page} of {totalPages}</span>
                            <button onClick={goNext} disabled={isLoading || page >= totalPages}>Next ›</button>
                            <button onClick={() => goToPage(totalPages)} disabled={isLoading || page >= totalPages}>Last ⏭</button>
                          </div>
                        </div> */}
                        </>
                      ) : (
                        <div className={style.emptyState}>
                          <span>No Job Execution Records to Show for The latest Events.</span>
                          {statusFilter || jobNameFilter ? ( <button
                          className={style.emptyStateButton}
                          onClick={()=>{
                            setTempStatusFilter(null)
                            setTempJobNameFilter(null)
                            setStatusFilter(null)
                            setJobNameFilter(null)
                            // setJobNameSearch("")
                              loadJobs({ nextPage: 1, nextLimit: limit, nextStatus: null, nextJobName: null });
                          }}
                          >Clear All Filters</button>): ""}
                        </div>
                      )}
                    </div>
                  )}
                  <div className={style.paginationWrap}>
                          <PaginationBar
                            currentPage={page}
                            totalPages={totalPages}
                            onPageChange={(p) => {
                              goToPage(p); // or fetchJobMonitorDetails(p, limit)
                            }}
                            maxVisiblePages={5}
                            disabled={isLoading}
                          />
                        </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {dqMonitorTab && <DataQuality setDqMonitorTab={setDqMonitorTab} />}
        {jobMonitorTab && (
          <JobMonitor
            chartData={jobTimeData}
            jobMonitorData={jobMonitorData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            fetchJobMonitorDetails={fetchJobMonitorDetails}
            jobExecutionStatus={jobExecutionStatus}
            jobExecutionHistory={jobExecutionHistory}
            jobExecutionHistoryChartData={jobExecutionHistoryChartData}
            setJobMonitorTab={setJobMonitorTab}
            setJobDurationStartDate={setJobDurationStartDate}
            setJobDurationEndDate={setJobDurationEndDate}
            jobDurationStartDate={jobDurationStartDate}
            jobDurationEndDate={jobDurationEndDate}
            setJobExecutionStartDate={setJobExecutionStartDate}
            setJobExecutionEndDate={setJobExecutionEndDate}
            jobExecutionStartDate={jobExecutionStartDate}
            jobExecutionEndDate={jobExecutionEndDate}
          />
        )}
      </div>

      <Modal show={showInfoModal} onHide={closeInfoModal} centered size="lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{infoRow?.job_name ?? "Job Details"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {infoRow ? (
            <div className={style.popoverBody}>
              <div style={{ display: "grid", gap: 8 }}>
                <div>
                  <strong>Job Execution ID:</strong> {infoRow.job_execution_id}
                  <FaCopy
                    className={style.copyIcon}
                    onClick={() => handleCopyToClipboard(infoRow.job_execution_id)}
                    title="Copy to clipboard"
                  />
                </div>
                <div>
                  <strong>Pipeline Execution ID:</strong> {infoRow.pipeline_execution_id || "N/A"}
                </div>
                <div>
                  <strong>Layer:</strong> {infoRow.layer}
                </div>
                <div>
                  <strong>Job Step Type:</strong> {infoRow.job_step_type_name}
                </div>
                <div>
                  <strong>Job Task Group:</strong> {infoRow.job_task_group_name}
                </div>
                <div>
                  <strong>Job Task:</strong> {infoRow.job_task_name}
                </div>
                <div>
                  <strong>data_source_entity/target_entity</strong>
                  {["data_source_entity/target_entity"]}
                </div>
                <div>
                  <strong>Job Task Start Time:</strong>{" "}
                  {infoRow.job_task_start_time || infoRow.job_start_time}
                </div>
                <div>
                  <strong>Job Task End Time:</strong>{" "}
                  {infoRow.job_task_end_time || infoRow.job_end_time}
                </div>
                <div>
                  <strong>Job Task Elapsed Time:</strong>{" "}
                  {infoRow.job_task_elapsed_time || infoRow.job_elapsed_time}
                </div>
                <div>
                  <strong>Job Task Status:</strong> {infoRow.job_task_status || infoRow.job_task_status}
                </div>
                <div>
                  <strong>data_source_entity/target_entity:</strong>{" "}
                  {infoRow?.["data_source_entity/target_entity"] ?? "N/A"}
                </div>
              </div>
            </div>
          ) : null}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeInfoModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DashBoard;
